import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { RouterModule } from '@angular/router'
import {
  AnimatedRemoteComponent,
  ButtonComponent,
  ErrorRetryComponent,
  IconComponent,
  LineLoaderComponent,
  PageLayoutComponent,
  StopPropagationDirective,
} from '@ftr/foundation'
import { CollapsibleListComponent } from '@ftr/lists'
import { ActionDropdownMenuComponent } from '@ftr/menus'
import { UserNamePipe } from '../../pipes'
import { UserGroupPermissionsListComponent } from '../permissions-list'
import { UserGroupPermissionsListItemComponent } from '../user-group-permission-list-item'
import { UserProfileGroupsListComponent } from '../user-groups-list'
import { UserProfileAdminViewComponent } from '../user-profile-admin-view'
import { UserProfileDetailsComponent } from '../user-profile-details'

@NgModule({
  imports: [
    ActionDropdownMenuComponent,
    AnimatedRemoteComponent,
    ButtonComponent,
    CollapsibleListComponent,
    CommonModule,
    ErrorRetryComponent,
    IconComponent,
    LineLoaderComponent,
    PageLayoutComponent,
    RouterModule,
    UserNamePipe,
    StopPropagationDirective,
  ],
  exports: [UserProfileDetailsComponent, UserProfileAdminViewComponent, UserGroupPermissionsListComponent],
  declarations: [
    UserProfileDetailsComponent,
    UserGroupPermissionsListComponent,
    UserGroupPermissionsListItemComponent,
    UserProfileGroupsListComponent,
    UserProfileAdminViewComponent,
  ],
})
export class UserProfileSharedModule {}
